import { useReportTemplatesStore } from "@/store/modules/reportTemplates";
import { VITE_APP_ATMO_SERVICE_ID } from "@/env";
import { multiGuard } from "@/utils/router";

const SampleFlasks = () =>
  import(
    /* webpackChunkName: "Samples" */ "@/components/atmo/projects/project/samples/SampleFlasks.vue"
  );

const fetchReportTemplates = async (to, from, next) => {
  const reportTemplatesStore = useReportTemplatesStore();
  if (!reportTemplatesStore.reportTemplateList.length) {
    reportTemplatesStore.fetchReportTemplates(VITE_APP_ATMO_SERVICE_ID);
  }
  next();
};

export default [
  {
    path: "",
    name: "project-samples",
    component: SampleFlasks,
    beforeEnter: multiGuard([fetchReportTemplates]),
  },
  {
    path: "order-forms",
    name: "samples-order-forms",
    component: SampleFlasks,
    beforeEnter: multiGuard([fetchReportTemplates]),
  },
  {
    path: "analysis-results",
    name: "samples-analysis-results",
    component: SampleFlasks,
    beforeEnter: multiGuard([fetchReportTemplates]),
  },
];
